import { z } from 'zod';
import { createWithdrawAmountSchema } from '@/entities/operation';
import type { WithdrawCardFormValues } from './types';

export const createWithdrawCardFormSchema = (
  minWithdraw?: number,
  maxAvailable?: number,
  totalAmount?: number,
  maxWithdraw?: number,
  maxWithdrawMessage?: string
) => {
  return z.object({
    currencyCode: z.string().nonempty({ message: '' }),
    cardNumber: z
      .string()
      .nonempty({ message: '' })
      .regex(new RegExp('^[0-9*]+$'), {
        message: '',
      })
      .refine(val => val.length === 16, {
        message: '',
      }),
    cardholderName: z.string().nonempty({ message: '' }),
    isCardholderCard: z.boolean().refine(val => val === true, {
      message: '',
    }),
    amount: createWithdrawAmountSchema({
      minWithdraw,
      maxAvailable,
      requireMaxAvailable: true,
      totalAmount,
      maxWithdraw,
      maxWithdrawMessage,
    }),
    includeFee: z.boolean().default(false),
  }) satisfies z.ZodType<WithdrawCardFormValues>;
};
